export enum EnumPermisos {
    PERMISO_CONFIGURACION_GENERAL = 'PERMISO_CONFIGURACION_GENERAL',
    PERMISO_PROYECTOS_CREAR = 'PERMISO_PROYECTOS_CREAR',
    PERMISO_PROYECTOS_EDITAR = 'PERMISO_PROYECTOS_EDITAR',
    PERMISO_PROYECTOS_ELIMINAR = 'PERMISO_PROYECTOS_ELIMINAR',
    PERMISO_PROYECTOS_VER = 'PERMISO_PROYECTOS_VER',
    PERMISO_REPORTES_GENERALES_VER = 'PERMISO_REPORTES_GENERALES_VER',
    PERMISO_USUARIOS_CREAR = 'PERMISO_USUARIOS_CREAR',
    PERMISO_USUARIOS_EDITAR = 'PERMISO_USUARIOS_EDITAR',
    PERMISO_USUARIOS_ELIMINAR = 'PERMISO_USUARIOS_ELIMINAR',
    PERMISO_USUARIOS_VER = 'PERMISO_USUARIOS_VER',
    PERMISO_TAREAS_CREAR = 'PERMISO_TAREAS_CREAR',
    PERMISO_TAREAS_EDITAR = 'PERMISO_TAREAS_EDITAR',
    PERMISO_TAREAS_CANCELAR = 'PERMISO_TAREAS_CANCELAR',
    PERMISO_TAREAS_VER = 'PERMISO_TAREAS_VER',
    PERMISO_MATERIALES_CREAR = 'PERMISO_MATERIALES_CREAR',
    PERMISO_MATERIALES_EDITAR = 'PERMISO_MATERIALES_EDITAR',
    PERMISO_MATERIALES_ELIMINAR = 'PERMISO_MATERIALES_ELIMINAR',
    PERMISO_MATERIALES_VER = 'PERMISO_MATERIALES_VER',
    PERMISO_VER_AGENDA = 'PERMISO_VER_AGENDA',
    PERMISO_VER_COTIZADOR = 'PERMISO_VER_COTIZADOR',
    PERMISO_GESTION_ARCHIVOS_VER = 'PERMISO_VER_PORTAL_CLIENTE',
    PERMISO_REPORTES_CLIENTE_VER = 'PERMISO_REPORTES_CLIENTE_VER',
    // Permisos por reporte individual
    PERMISO_REPORTE_HORAS_HOMBRE_VER = 'PERMISO_REPORTE_HORAS_HOMBRE_VER',
    PERMISO_ASISTENTE_IA_VER = 'PERMISO_ASISTENTE_IA_VER',
}